import React from "react";
import { Box, useTheme } from "@mui/material";
import {
  HeatMaterialWithColor,
  MixValueMode,
} from "components/strategyDashboard/heats/types";
import { HeatMixPlotLayer } from "./HeatMixPlotLayer";

interface HeatMixPlotProps {
  isFirst: boolean;
  materials: HeatMaterialWithColor[];
  mixValueMode?: MixValueMode;
}

export const HeatMixPlot: React.FC<HeatMixPlotProps> = ({
  materials,
  isFirst,
  mixValueMode = "mass",
}) => {
  const theme = useTheme();

  return (
    <Box
      sx={{
        border: `2px solid ${theme.palette.grey[400]}`,
        borderRadius: 1,
        display: "flex",
        flexDirection: "column",
        position: "relative",
        width: "100%",
      }}
    >
      {/* Materials */}
      <Box
        sx={{
          display: "flex",
          flexDirection: "column-reverse",
        }}
      >
        {materials.map((material, index) => (
          <HeatMixPlotLayer
            // eslint-disable-next-line @eslint-react/no-array-index-key
            key={`${material.name}-${index}`}
            material={material}
            height={40}
            isFirst={isFirst}
            mixValueMode={mixValueMode}
          />
        ))}
      </Box>
    </Box>
  );
};
